import { DateTime } from 'luxon';

import type { CandidateTrip } from './buildDuplicateCriteria';
import { TripSpaceTypeBadge } from 'src/features/trip/management/TripSpaceTypeBadge';
import { TripStatusBadge } from 'src/features/trip/management/TripStatusBadge';

export function DuplicateTripCard({ trip }: { trip: CandidateTrip }) {
  const pickupAt = trip.scheduled_pickup_at
    ? DateTime.fromISO(trip.scheduled_pickup_at).toFormat('LLL dd, yyyy h:mm a')
    : '';

  return (
    <div className="rounded-md border border-gray-200 bg-white p-3 text-sm">
      <div className="flex items-center justify-between gap-2">
        <span className="font-mono text-xs text-gray-500">
          {trip.confirmation_code}
        </span>
        <div className="flex items-center gap-1">
          <TripSpaceTypeBadge spaceType={trip.space_type} />
          <TripStatusBadge status={trip.status} />
        </div>
      </div>
      <div className="mt-1 font-medium">{pickupAt}</div>
      <div className="mt-1 text-gray-700">
        <div>Pickup: {trip.pickup.address}</div>
        <div>Dropoff: {trip.dropoff.address}</div>
      </div>
    </div>
  );
}
